import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { AccountancySendEmailSingleCommand, AccountancySendEmailSingleCommandHandlerBase } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(AccountancySendEmailSingleCommand)
@Injectable({ providedIn: 'root'})
export class AccountancySendEmailSingleCommandHandler {
    private commandHandler: AccountancySendEmailSingleCommandHandlerBase;

    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new AccountancySendEmailSingleCommandHandlerBase(http);
    }

    public async handleAsync(params: AccountancySendEmailSingleCommand): Promise<void> {
        await this.commandHandler.handleAsync(params);
    }
}
